var map = {
	"./default": [
		95174
	],
	"./default.ts": [
		95174
	],
	"./hungarian": [
		45717,
		717
	],
	"./hungarian.ts": [
		45717,
		717
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 70948;
module.exports = webpackAsyncContext;